require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-three-perks-software-developer.json") })
        }
      }, "path---blog-three-perks-software-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-three-perks-software-developer!./.cache/json/blog-three-perks-software-developer.json
// module id = 1133
// module chunks = 231608221292675